export default "__VITE_ASSET__721f9717__"